import React, {Component} from "react";
import FlexView from "react-flexview";
import {connect} from "react-redux";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleDDL from "../../../modules/SimpleDDL";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../common/mapper";
import MasterPenjualanCreate from "./masterPenjualanCreate";
import MasterPenjualanEdit from "./masterPenjualanEdit";
import MasterPenjualanFilter from "./masterPenjualanFilter";
import * as R from "ramda";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import {HttpStatus} from "../../common/Constants";
import {fetchDataAsync} from "../../../Services/Utils";

class MasterPenjualan extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "userName",
            label: "Username",
        },
        {
            name: "salesLeadName",
            label: "Nama Team Lead",
        },
        {
            name: "cabang",
            label: "Cabang",
        },
        {
            name: "salesType",
            label: "Team Lead",
        },
        {
            name: "salesId",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <div>
                        <SimpleButton
                            className="btnAct"
                            category="action_button"
                            style={{marginRight: 15, backgroundColor: "transparent"}}
                            onClick={() => this.handleEditVisibility(rowIndex)}
                            icon={
                                <i
                                    className="fa fa-users"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            }
                        />
                        <SimpleButton
                            className="btnAct"
                            category="action_button"
                            style={{marginRight: 15, backgroundColor: "transparent"}}
                            onClick={() => this.handleConfirmDeletePopupVisibility(val, rowIndex)}
                            icon={
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            }
                        />
                    </div>
                ),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            selectedData: null,
            createVisible: false,
            loading: false,
            filterVisible: false,
            printVisible: false,
            kodeCabang: null,
            cabangOptions: [],
            filterData: {},
            submittedFilterData: {},
            deleteIdx: null,
            deleteId: "",
            pagination: {
                totalData: 1,
                limit: 5,
                page: 1,
            },
            dataTable: [],
        };
    }

    componentDidMount = async () => {
        await this.fetchDataCabang();
    };

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
    }

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: null,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );

            if (filteredData.length !== 0) {
                await this.setState((prevValue) => ({
                    ...prevValue,
                    cabangOptions: filteredData.map(item => mapToObjectDDL(item.namaDealer, item.kodeCabang)),
                    kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang)
                }))
            }

            await this.fetchData({kodeCabang: this.state.kodeCabang?.value});
        }
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading,}));
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({
            ...prevValue,
            isFetch: true,
            pagination: {...prevValue.pagination, totalData: 0}
        }));
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: {
                paramFilters: {
                    kodeCabang: this.state.kodeCabang?.value || "",
                    ...filter,
                },
                page,
                limit,
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                    page,
                    limit,
                },
                dataTable: response.data.data || [],
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handlePrintVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printVisible: !prevValue.printVisible,
        }));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleResetFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    handleSubmitFilter = async (e) => {
        e.preventDefault();
        this.handleTriggerLoading();
        this.handleFilterVisibility();
        if (this.state.filterData?.kodeCabang) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeCabang: this.state.filterData.kodeCabang,
            }));
        }
        const request = removeNullFields({
            ...this.state.filterData,
            kodeCabang: getValueFromDDL(this.state.filterData, "kodeCabang"),
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: request,
        }));
        this.handleTriggerLoading();
    };

    handleEditVisibility = (index) => {
        if (index >= 0) {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: this.state.dataTable[index],
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: null,
        }));
    };

    handleCreateVisibility = () => {
        this.setState((prevValue) => ({...prevValue, createVisible: !prevValue.createVisible}));
    };

    handleCabangChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
            submittedFilterData: {},
            filterData: {},
        }));
        this.handleTriggerLoading();
        await this.fetchData({
            kodeCabang: value.value,
        });
        this.handleTriggerLoading();
    };

    handleConfirmDeletePopupVisibility = (val, id) => {
        if (!R.isNil(id)) {
            this.setState((prevValue) => ({
                ...prevValue,
                deleteIdx: id,
                deleteId: val,
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            deleteId: "",
            deleteIdx: null,
        }));
    };

    handleDeleteSalesLead = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteSalesLead,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: this.state.deleteId
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
        }
        this.handleConfirmDeletePopupVisibility();
        this.handleTriggerLoading();
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between"}}
                        vAlignContent="center"
                        className="margin-top-5px"
                    >
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama cabang hak akses"
                            options={this.state.cabangOptions}
                            value={this.state.kodeCabang}
                            onChange={(value, {name}) => this.handleCabangChange(name, value)}
                        />
                        <Button
                            type="button"
                            className="btn background-red margin-bottom-20px"
                            onClick={this.handleFilterVisibility}
                        >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                        </Button>
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.totalData}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    onClick={this.handleCreateVisibility}
                                >
                                    Tambah
                                </SimpleButton>
                                <SimpleButton secondary onClick={this.handlePrintVisibility}>
                                    Cetak
                                </SimpleButton>
                            </>
                        }
                    />
                </Container>
                {this.state.filterVisible && (
                    <MasterPenjualanFilter
                        {...this.props}
                        state={this.state}
                        cabangOptions={this.state.cabangOptions}
                        triggerLoading={this.handleTriggerLoading}
                        onClickClose={this.handleFilterVisibility}
                        onReset={this.handleResetFilter}
                        onSubmit={this.handleSubmitFilter}
                        onValueChange={this.handleValueChange}
                    />
                )}
                {this.state.selectedData && (
                    <MasterPenjualanEdit
                        {...this.props}
                        triggerLoading={this.handleTriggerLoading}
                        kodeCabang={this.state.kodeCabang?.value}
                        data={this.state.selectedData}
                        onClickClose={() => this.handleEditVisibility()}
                        onFetch={() => this.fetchData(this.state.submittedFilterData, this.state.pagination.page, this.state.pagination.limit)}
                    />
                )}
                {this.state.createVisible && (
                    <MasterPenjualanCreate
                        {...this.props}
                        triggerLoading={this.handleTriggerLoading}
                        kodeCabang={this.state.kodeCabang?.value}
                        visible={this.state.createVisible}
                        onClickClose={this.handleCreateVisibility}
                        onFetch={() => this.fetchData(this.state.submittedFilterData, this.state.pagination.page, this.state.pagination.limit)}
                    />
                )}
                {!R.isNil(this.state.deleteIdx) && (
                    <SimpleAlert
                        title="Information"
                        visible={!R.isNil(this.state.deleteIdx)}
                        onClickClose={() => this.handleConfirmDeletePopupVisibility()}
                        content={
                            <>
                                <p>Penghapusan data Team Lead akan menghapus data Tim Sales. Apakah anda yakin ?</p>
                                <FlexView hAlignContent="center" className="margin-top-15px">
                                    <SimpleButton secondary onClick={() => this.handleConfirmDeletePopupVisibility()}>
                                        Batal
                                    </SimpleButton>
                                    <SimpleButton onClick={this.handleDeleteSalesLead}>Iya</SimpleButton>
                                </FlexView>
                            </>
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                {this.state.printVisible && <SimplePrintTable onClearPrint={this.handlePrintVisibility}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterPenjualan);
